import { render, staticRenderFns } from "./40-beauty.vue?vue&type=template&id=00ed7a9b"
import script from "./40-beauty.vue?vue&type=script&lang=js"
export * from "./40-beauty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.90.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports